import * as React from 'react';
import * as lodash from 'lodash';
import '@ant-design/compatible/assets/index.css';
import { Row, Col } from 'antd';
import { Image, Tooltip, Modal, Carousel, Typography, message, Spin } from 'src/design-system/components/atoms';
import { LeftCircleOutlined, LoadingOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { formatDate, formatDateTime } from '@utils/utils';
import { getDetailsRoute, getRetailTripDetailsRoute } from '@routing/utils';
import {
  getTMSIstDetailsRoute,
  getTMSBagDetailsRoute,
} from '@components/pages/TMSDashboard/routes';
import { getConsignmentStatusPrettyName } from '@utils/consignmentStatus';
import {
  getRetailConsignmentStatus,
  tripStatusPrettyNames,
  getRetailInTripConsignmentStatus,
} from '@utils/retailConsignment';
import * as moment from 'moment';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '@theming/jssTypes';
import { connect } from 'react-redux';

const PreviewGroup = Image.PreviewGroup;

import { InfoCircleOutlined, WarningFilled } from '@ant-design/icons';
import EwayBillListModal from '../EwayBillListModal';
import PriceDataListModal from '../PriceDataListModal';
import InvoiceListModal from '../InvoiceListModal';
import EwayBillPartBListModal from '../EwayBillPartBListModal';
import useGenericState from '@hooks/useGenericState';
import TableModal from '@components/common/TableModal';
import GalleryModal from 'src/design-system/components/molecules/GalleryModal/GalleryModal';
import PodImageModal from '@components/pages/FoodDashboard/PodImageModal';
import TextModal from '@components/common/TextModal';
import { getPickupRequestDetailsRoute } from '@routing/utils';
import TextWithEllipsisAndTooltip from 'src/design-system/components/atoms/TextWithEllipsisAndTooltip/TextWithEllipsisAndTooltip';
import { givenPaymentDetailsColumns, geocodingUpdatesColumn } from './columns';
import DocumentLinkModal from '@components/common/DocumentLinkModal';
import DocumentDetailsModal from '@components/common/DocumentDetailsModal';
import { useTranslation } from 'react-i18next';
import JsonArrayTableViewModal from 'src/components/pages/dashboard/JsonArrayTableViewModal';
import { getAppliedExceptions } from 'src/api/TMSDashboard/Setup';
import ExceptionDetailsModal from '../ExceptionDetailsModal';
import CustomerFeedbackModal from '@components/common/CustomerFeedbackModal';
import { getConsignmentExtraData } from '@api/dashboard';
import { useTheme } from 'src/theming/useTheme';

interface GalleryModalData {
  images: string[];
  videos: string[];
  pdfs: string[];
}

const { useState } = React;
const { Paragraph } = Typography;

const styles = (theme: ThemeType): CssType => ({
  container: {},
  loader: {
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    height: '48px',
    padding: `${theme.spacing[0]} ${theme.spacing[8]}`,
    backgroundColor: theme.color.semantic.background.neutral.subtle,
    fontSize: theme.typography.fontSize.md,
    fontWeight: theme.typography.fontWeight.bold,
    display: 'flex',
    alignItems: 'center',
    color: theme.color.semantic.text.secondary,
  },
  rowContainer: {
    padding: `${theme.spacing[0]} ${theme.spacing[2]} ${theme.spacing[0]} ${theme.spacing[8]}`,
    marginBottom: theme.spacing[5],
  },
  hintHeader: {
    fontSize: theme.typography.fontSize.xs,
    color: theme.color.semantic.text.tertiary,
    fontWeight: theme.typography.fontWeight.regular,
    margin: `${theme.spacing[1]} ${theme.spacing[0]} ${theme.spacing[1]} ${theme.spacing[0]}`,
  },
  content: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.color.semantic.text.primary,
    fontWeight: theme.typography.fontWeight.medium,
    wordBreak: 'break-word',
    textTransform: 'capitalize',
  },
  column: {
    margin: `${theme.spacing[2]} ${theme.spacing[0]}`,
  },
  btn: {
    color: theme.color.semantic.brand.default.secondary,
    cursor: 'default',
  },
  modalContainer: {
    padding: `${theme.spacing[4]} ${theme.spacing[0]}`,
    paddingBottom: theme.spacing[6],
  },
  epdModalContainer: {
    paddingTop: theme.spacing[0],
  },
  carouselContainer: {
    padding: theme.spacing[3],
    maxWidth: '100%',
    '& span > svg': {
      width: '120%',
      height: '120%',
    },
  },
  viewDetails: {
    color: theme.color.semantic.brand.default.secondary,
    cursor: 'pointer',
  },
});

const DetailsCard = (props: any) => {
  const {
    title,
    data,
    columns,
    classes,
    allowPartialDelivery,
    getCustomDetailsCard,
    objectType,
    showChildCns,
  } = props;
  const [visible, setVisible] = React.useState(false);
  const [galleryData, setGalleryData] = React.useState(null);
  const [isEwayBillListModalVisible, setEwayBillListModalVisible] =
    useState(false);
  const [isPriceDataListModalVisible, setIsPriceDataListModalVisible] =
    useState(false);
  const [priceDataList, setPriceDataList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [isInvoiceListModalVisible, setIsInvoiceListModalVisible] = useState(false);
  const [isEwayBillPartBListModalVisible, setEwayBillPartBListModalVisible] =
    useState(false);
  const [ewayBillList, setEwayBillList] = useState([]);
  const [isGalleryModalVisible, setIsGalleryModalVisible] = React.useState(false);
  const [galleryModalData, setGalleryModalData] =
    React.useState<GalleryModalData>({ images: [], videos: [], pdfs: [] });
  const [mediaList, setMediaList] = React.useState([]);
  const [documentDetails, setDocumentDetails] = React.useState(null);
  const [documentLinkModalVisible, setDocumentLinkModalVisible] = React.useState(false);
  const [jsonArrayFieldListModalProps, setJsonArrayFieldListModalProps] = React.useState({
    data: [],
    isVisible: false,
    key: '',
  });
  const [appliedExceptionsList, setAppliedExceptionsList] = React.useState([]);
  const [isExceptionsAppliedTableVisible, setIsExceptionsAppliedTableVisible] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isCustomerFeedbackModalVisible, setIsCustomerFeedbackModalVisible] = React.useState(false);
  const [pickupExtraData, setPickupExtraData] = useState(null);
  const [isPickupExtraDataModalVisible, setIsPickupExtraDataModalVisible] = useState(false);
  const theme = useTheme();


  const initialState = {
    isTableModalVisible: false,
    isPodModalVisible: false,
    dataSource: [],
    podImagesList: [],
    columnsData: [],
    header: '',
  };

  const [state, setState] = useGenericState(initialState);

  const {
    isTableModalVisible,
    isPodModalVisible,
    dataSource,
    podImagesList,
    columnsData,
    header,
  } = state;

  const renderGalleryModal = (
    imageArray: any[],
    videoArray: any[],
    pdfArray: any[],
    mediaListArray: any[] = [],
  ) => {
    const hasMedia = imageArray.length > 0 ||
      videoArray.length > 0 ||
      pdfArray.length > 0 ||
      mediaListArray.length > 0;
    if (!hasMedia) return t('not available');
    return (
        <a onClick={() => {
            setGalleryModalData({
                images: imageArray,
                videos: videoArray,
                pdfs: pdfArray,
            });
            setMediaList(mediaListArray);
            setIsGalleryModalVisible(true);
        }}
        >
            {t('View')}
        </a>
    );
};

  const renderInvoiceList = (ewayBill, ewayBillList, invoiceList = [], invoiceNumber, invoiceValue) => {
    try {
      ewayBill = JSON.parse(ewayBill.trim());
    } catch (err) {
      ewayBill = null;
    }
    if (ewayBill) {
      const isEwayBillFoundInList = ewayBillList?.length ? ewayBillList.find(ewayBillObj => ewayBillObj.invoiceNumber === ewayBill.invoiceNumber) : false;
      if (!isEwayBillFoundInList) {
        ewayBillList = ewayBillList || [];
        ewayBillList.push(ewayBill);
      }
    }
    if(invoiceNumber && invoiceValue){
      const isInvoiceFoundInList = invoiceList?.length ? invoiceList.find(invoiceObj => invoiceObj.invoiceNumber === invoiceNumber) : false;
      if (!isInvoiceFoundInList) {
        invoiceList.push({invoiceNumber: invoiceNumber, invoiceValue: invoiceValue});
      }
    }
    ewayBillList = ewayBillList.filter(ewayBillObj => ewayBillObj.invoiceNumber);
    invoiceList = invoiceList.filter(invoiceObj => invoiceObj.invoiceNumber);
    let dataToRender = [
      ...invoiceList,
      ...ewayBillList,
    ];
    dataToRender = lodash.uniqBy(dataToRender, 'invoiceNumber');

    setIsInvoiceListModalVisible(true);
    setInvoiceList(dataToRender);
  };
  
  const showExceptionDetailsModal = async(record) => {
      setIsLoading(true);
      const response = await getAppliedExceptions(record.reference_number);
      setIsLoading(false);
      if(!response.isSuccess){
        message.error(response.errorMessage);
        return;
      }
      setAppliedExceptionsList(response.data);
      setIsExceptionsAppliedTableVisible(true);
  };

  const renderPriceDataList = (priceData) => {
    setIsPriceDataListModalVisible(true);
    setPriceDataList(priceData);
  };

  const renderPriceDetails = (data) => {
    if (Array.isArray(data) && data.length) {
      const finalPriceObject = data.find((price) => (price.id === 'finalPrice'));
      if (!finalPriceObject) {
        return t('not available');
      }
      const filteredPriceData = data.filter((price) => price.id !== 'finalPrice');
      return (
      <span>
        {(finalPriceObject['value'] || 0)?.toString()}
        <Tooltip title="">
          <a>
            <InfoCircleOutlined
              style={{ marginLeft: theme.spacing[1] }}
              onClick={() => renderPriceDataList(filteredPriceData)}
            ></InfoCircleOutlined>
          </a>
        </Tooltip>
      </span>);

    }
    return t('not available');
  };
  const renderLatLong = (renderData, data = []) => {
    return (
    <>
      {renderData}
      {data.length ? (
        <span>
          <Tooltip title="">
            <a>
              <InfoCircleOutlined
                style={{ marginLeft: theme.spacing[1] }}
                onClick={() => {
                  setState({
                    isTableModalVisible: true,
                    dataSource: data,
                    columnsData: geocodingUpdatesColumn,
                    header: 'Geocoding Updates',
                  });
                }}
              ></InfoCircleOutlined>
            </a>
          </Tooltip>
        </span>
      ) : <></>}
    </>);
  };

  const handleExpectedPickupDetailsClick = async (referenceNumber) => {
    if (!referenceNumber) {
      return;
    }
    setPickupExtraData(null);
    setIsLoading(true);
    const response = await getConsignmentExtraData({
      reference_number: referenceNumber,
      type: 'edd_epd_calculation',
    });
    setIsLoading(false);
    if (!response?.isSuccess) {
      message.error(response?.errorMessage || t('Something went wrong'));
      return;
    }
    setPickupExtraData(response?.data || {});
    setIsPickupExtraDataModalVisible(true);
  };

  const renderExpectedPickupDate = (column, record) => {
    const formattedDate = formatDate(record[column?.id], t('not available'));
    if (!record[column?.id] || !record?.reference_number) {
      return formattedDate;
    }
    return (
      <span>
        {formattedDate}
        <Tooltip title="">
          <a>
            <InfoCircleOutlined
              style={{ marginLeft: theme.spacing[1] }}
              onClick={() => handleExpectedPickupDetailsClick(record?.reference_number)}
            />
          </a>
        </Tooltip>
      </span>
    );
  };

  const getDataToRender = (column, data) => {
    if (column.type === 'boolean') {
      return renderBooleanData(column, data);
    }
    if (column.type === 'Array') {
      return renderArrayData(column, data);
    }
    if (column.type === 'date') {
      switch (column.id) {
        case 'hub_arrival_time':
        case 'delivery_completion_time':
        case 'delivery_time_slot_start':
        case 'delivery_time_slot_end':
        case 'pickup_time_slot_start':
        case 'pickup_time_slot_end':
        case 'softdata_upload_time':
        case 'load_time_ondemand_timestamp':
        case 'order_time_ondemand':
        case 'makeline_time_ondemand':
          return formatDateTime(parseInt(data[column.id], 10));
        case 'expected_delivery_date':
        case 'promised_delivery_date':
          return formatDate(data[column.id], t('not available'));
        case 'expected_pickup_date':
          return renderExpectedPickupDate(column, data);
        default:
          return formatDate(data[column.id], t('not available'));
      }
    }
    if (column.type === 'url') {
      return renderUrlData(data[column.id]);
    }
    if (column.type === 'jsonArray') {
      return (
       (Array.isArray(data[column.id]) && data[column.id].length) ? (
          <div
            className={classes.viewDetails}
            onClick={() => setJsonArrayFieldListModalProps({
              data: data[column.id],
              isVisible: true,
              key: column.id,
            })}
          >View Details</div>
        ) : '-'
      );
    }
    if (column.type === 'datetime') {
      return formatDateTime(data[column.id]);
    }
    switch (column.id) {
      case 'movement_type':
      case 'consignment_type':
        return data[column.id] !== null && data[column.id] !== undefined
          ? data[column.id]
          : 'Forward';
      case 'split_original_reference_number':
      case 'forward_reference_number':
      case 'rto_reference_number':
      case 'parent_consignment_reference_number':
        return renderReferenceNos(data[column.id]);
      case 'bag_reference_number':
        return renderBagNo(data[column.id]);
      case 'trip_organisation_reference_number':
      case 'hubtohub_trip_organisation_reference_number':
      case 'endpoint_trip_organisation_reference_number':
      case 'pickup_trip_number':
      case 'delivery_trip_number':
        return renderTripNumber(data[column.id]);
      case 'middle_mile_trip_number':
        return renderTripNumber(data[column.id], true);
      case 'latest_pickup_task_reference_number':
        return renderPickupTaskReferenceNumber(data[column.id]);
      case 'status':
        return (
          <>
            {t(getConsignmentStatusPrettyName(data[column.id]))}
            { data.is_partial_delivery ? (
              <Tooltip title={t('Partially Delivered')}>
                <WarningFilled
                  style={{ fontSize: theme.typography.fontSize.lg, color: theme.color.semantic.accent.orange.strong, marginLeft: theme.spacing[2] }}
                />
              </Tooltip>
            ) : data.is_partial_pickup === 'Yes' ?
            (
              <Tooltip title={t('Partially Pickedup')}>
                <WarningFilled
                  style={{ fontSize: theme.typography.fontSize.lg, color: theme.color.semantic.accent.orange.strong, marginLeft: theme.spacing[2] }}
                />
              </Tooltip>
            ) : <></>}
          </>
        );
      case 'invoice_number': 
        const invoiceList = lodash.get(data, 'extra_details.invoice_list', []);
        const invoiceNumber = lodash.get(data, 'extra_details.invoice_number', '');
        const invoiceValue = lodash.get(data, 'extra_details.declared_value', '');
        return (
          <Tooltip title="">
            <a>
              <div
                onClick={() => renderInvoiceList(data['eway_bill'], data['eway_bill_list'], invoiceList, invoiceNumber, invoiceValue)}
              >{t('View')}</div>
            </a>
          </Tooltip>
        );
      case 'cod_amount':
        return data[column.id] || 0;
      case 'cod_amount_collected':
        return data['amount_collected']  || t('not available');
      case 'signature_image':
      case 'pop_signature_image':
      case 'pod_image':
      case 'poa_image':
      case 'delivery_kyc_image':
      case 'reference_image_url':
      case 'pickup_premise_image':
      case 'card_transaction_image':
      case 'pickup_signature_image':
        return data[column.id] ? renderGalleryModal([data[column.id]], [], []) : t('not available');

      case 'delivery_time_slot_start':
      case 'delivery_time_slot_end':
      case 'pickup_time_slot_start':
      case 'pickup_time_slot_end':
        return data[column.id]
          ? moment(parseInt(data[column.id], 10)).format('HH:mm')
          : t('not available');
      case 'execution_status':
        return;
      case 'worker_comment':
        return renderTooltipParagraph(data[column.id]);
      case 'ewb_partb_generation_time':
        return renderEWBPartBGenerationTime(data[column.id]);
      case 'destination_lat': {
        const destLat = Array.isArray(data.delivery_location) && data.delivery_location.length === 2
          ? data.delivery_location[0]
          : null;
        return destLat ? renderLatLong(destLat, data.destination_location_trail) : '_';
      }
      case 'destination_lon': {
        const destLon = Array.isArray(data.delivery_location) && data.delivery_location.length === 2
          ? data.delivery_location[1]
          : null;
        return destLon ? renderLatLong(destLon, data.destination_location_trail) : '_';
      }
      case 'destination_latitude':
        return data.destination_latitude
          ? renderLatLong(data.destination_latitude, data.destination_location_trail)
          : t('not available');
      case 'destination_longitude':
        return data.destination_longitude
          ? renderLatLong(data.destination_longitude, data.destination_location_trail)
          : t('not available');
      case 'pickup_lat':
        return data.pickup_completed_event_details?.lat
          ? data.pickup_completed_event_details?.lat
          : t('not available');
      case 'pickup_lng':
        return data.pickup_completed_event_details?.lng
          ? data.pickup_completed_event_details?.lng
          : t('not available');
      case 'origin_lat':
        const originLat = Array.isArray(data.origin_location) &&
          data.origin_location?.length === 2
          ? data.origin_location[0]
          : '';
        return renderLatLong(originLat, data.origin_location_trail);
      case 'origin_lon':
        const originLon = Array.isArray(data.origin_location) &&
          data.origin_location?.length === 2
          ? data.origin_location[1]
          : '';
        return renderLatLong(originLon, data.origin_location_trail);
      case 'latest_delivery_geocode_difference':
        return (
          data?.latest_delivery_event?.geocode_location_difference ||
          t('not available')
        );
      case 'latest_pickup_geocode_difference':
        return (
          data?.latest_pickup_event?.geocode_location_difference ||
          t('not available')
        );
      case 'customer_feedback':
        return data.customer_feedback ? (
          <span
            onClick={() => setIsCustomerFeedbackModalVisible(true)}
            style={{ color: theme.color.semantic.brand.default.secondary, cursor: 'pointer' }}
          >
            {t('View')}
          </span>
        ) : (
          t('not available')
        );
      case 'document_link':
        return renderDocumentList(data);
      default:
        if (Array.isArray(data[column.id])) {
          return data[column.id].length ? data[column.id].join(', ') : '-';
        }
        return data[column?.id] ? data[column?.id] : t('not available');
    }
  };

  const getColumnPrettyName = (column) => {
    if(column.id === 'destination_lon') {
      return t('Completion Longitude');
    }
    if(column.id === 'destination_lat') {
      return t('Completion Latitude');
    }
    return t(column.pretty_name);
  };

  const renderBooleanData = (column, data) => {
    switch (column.id) {
      case 'is_cnv_done':
        return data[column.id] ? 'Verified' : 'Not Verified';
      case 'is_exception_applied':
        return (
          <span>
            {data[column.id] ? 'Yes' : 'No'}
            {
              data[column.id] && <InfoCircleOutlined style={{ marginLeft: theme.spacing[1] }} onClick={() => showExceptionDetailsModal(data)} />
            }
          </span>
        );
      default:
        return data[column?.id] ? 'Yes' : 'No';
    }
  };

  const getImageVideosFromPieces = (data) => {
    const pieceImagesToShow = [];
    const pieceVideosToShow = [];

    data['pieces_detail']?.map((piece) => {
      // Piece level images/videos
      const imageUrlListPiece = piece?._internal?.image_url_list?.map(
        (image) => {
          if (image && (typeof image === 'string' ? image.trim() : image?.url?.trim())) {
            pieceImagesToShow.push(image);
          }
        },
      );
      const videoUrlListPiece = piece?._internal?.video_url_list?.map(
        (video) => {
          if (video) {
            pieceVideosToShow.push(video);
          }
        },
      );
    });

    return { pieceImagesToShow, pieceVideosToShow };
  };

  const checkAndRenderGallery = (
    column,
    data,
    statusList,
    appendPieceImages = false,
    ignoreStatusCheck = false,
  ) => {
    if (!ignoreStatusCheck) {
      if (!statusList?.includes(data['status'])) {
        return t('not available');
      }
    }

    // Case 1: column.id[0] or column.id[1] has data
    if (data[column.id[0]]?.length > 0 || data[column.id[1]]?.length > 0) {
      const collectedMedia: any[] = [];
      const collectedVideos: any[] = [];

      data[column.id[0]]?.forEach((item) => {
        if (item && (typeof item === 'string' ? item.trim() : item?.url?.trim())) {
          collectedMedia.push(item);
        }
      });

      data[column.id[1]]?.forEach((item) => {
        if (item) {
          collectedVideos.push(item);
        }
      });

      if (appendPieceImages) {
        const { pieceImagesToShow, pieceVideosToShow } = getImageVideosFromPieces(data);
        pieceImagesToShow?.forEach((item) => {
          if (item) collectedMedia.push(item);
        });
        pieceVideosToShow?.forEach((item) => {
          if (item) collectedVideos.push(item);
        });
      }

      return renderGalleryModal([], collectedVideos, [], collectedMedia);
    }

    // Case 2: column.id[2] has data (single item)
    if (data[column.id[2]]) {
      return renderGalleryModal([], [], [], [data[column.id[2]]]);
    }

    // Case 3: column.id[3] has data (single item - RiderApp Field)
    if (data[column.id[3]]) {
      return renderGalleryModal([], [], [], [data[column.id[3]]]);
    }

    return t('not available');
  };

  const renderUrlData = (column) => {
    if (!column) return t('not available');
    return (
      <a href={column} target="_blank">
        Preview
      </a>
    );
  };

  const renderPaymentCollectionModeList = (data) => {
    return data?.length ? (
      <span>
        <TextWithEllipsisAndTooltip width="500px">
          {data.join(', ')}
        </TextWithEllipsisAndTooltip>
      </span>
    ) : (
      t('not available')
    );
  };

  const renderArrayData = (column, data) => {
    switch (column.key) {
      case '{current_delivery_address_line_1, current_delivery_address_line_2}':
      case '{destination_address_line_1, destination_address_line_2}':
      case '{sender_address_line_1, sender_address_line_2}':
      case '{hub_address_line_1, hub_address_line_2}':
      case '{return_address_line_1, return_address_line_2}':
        return renderAddress(column, data);
      case '{manifest_number, manifest_time}':
        return `${data.manifest_number ? data.manifest_number : t('not available')}
                      ${data.manifest_time ? data.manifest_time : ''}`;
      case '{start_time, end_time}':
        return renderETA(data[column.id[0]], data[column.id[1]]);
      case 'eway_bill':
        return renderEwayBillNo(data[column.id], data['eway_bill_list']);
      case 'eway_bill_expiry_date':
        return renderEwayBillValidity(data[column.id]);
      case 'eway_bill_part_b':
        return renderEwayBillPartB(data[column.id], data['eway_bill_list']);
      case 'customer_pod':
        return renderGalleryModal(data[column.id] || [], [], []);
      case '{height, width, length}':
        return showChildCns && !data.parent_reference_number ? '-' : column.id.length === 3 &&
          data[column.id[0]] &&
          data[column.id[1]] &&
          data[column.id[2]]
          ? `${data[column.id[0]]}*${data[column.id[1]]}*${data[column.id[2]]}`
          : t('not available');
      case 'pickup_attempt_proof':
        return checkAndRenderGallery(column, data, ['not_picked_up']);
      case '{given_height, given_width, given_length}':
        return showChildCns && !data.parent_reference_number ? '-' : column.id.length === 3 &&
          data[column.id[0]] &&
          data[column.id[1]] &&
          data[column.id[2]]
          ? `${data[column.id[0]]}*${data[column.id[1]]}*${data[column.id[2]]}`
          : t('not available');
      case 'attempt_proof':
        return checkAndRenderGallery(column, data, ['attempted'], true, false);
      case 'pop_image':
        if (data['status'] === 'not_picked_up') {
          //since images displayed under pickup_attempt_proof
          return t('not available');
        }
        return checkAndRenderGallery(column, data, [], false, true);
      case 'poc_image':
        return checkAndRenderGallery(
          column,
          data,
          ['delivered', 'rto_delivered', 'rvp_delivered', 'undelivered', 'attempted'],
          true,
        );
      case 'given_payment_details':
        return renderTableModal(
          data[column.id],
          givenPaymentDetailsColumns,
          'Amount Paid Details',
        );
      case 'pod_image_url':
        return renderPodImage(data[column.id]);
      case 'constraint_tags':
        return renderConstraintTags(data[column.id]);
      case 'vendor_image_url_list':
        return renderVendorPODList(data[column.id]);
      case 'quality_check_image_list':
        return renderGallery(data[column.id]);
      case 'price_details':
        return renderPriceDetails(data[column.id]);
      case 'courier_price_details':
        return renderPriceDetails(data.courier_price_details_list);
      case 'payment_collection_mode_list':
        return renderPaymentCollectionModeList(data[column.id]);
      default:
        return data[column.id] ? data[column.id] : t('not available');
    }
  };

  const renderDocumentList = (data) => {
    const docDetails = data?.document_details;
    return (
      docDetails ?
      <a
        onClick={() =>
          {
            setDocumentLinkModalVisible(true);
            setDocumentDetails(docDetails);
          }
        }
        style={{ color: theme.color.semantic.brand.default.secondary, cursor:'pointer' }}>{t('View')}
      </a>
      : t('not available')
    );
  };

  const renderVendorPODList = (podList) => {
    // directly send the pod list to the gallery modal
    return podList?.length > 0
      ? renderGalleryModal([], [], [], podList)
      : t('not available');
  };

  const renderGallery = (data) => {
    if (
      (Array.isArray(data) && !data.length) ||
      (!Array.isArray(data) && !data)
    ) {
      return t('not available');
    }
    return (
      <>
        <div
          onClick={() => {
            toggleGalleryWithData(data);
          }}
          className={classes.btn}
        >
          {t('View')}
        </div>
      </>
    );
  };

  const toggleGalleryWithData = (data = null) => {
    setVisible(!visible);
    setGalleryData(data);
  };

  const renderETA = (startTime, endTime) => {
    return startTime && endTime
      ? `${moment(startTime).format('Do MMMM')},
          ${moment(startTime).format('h A')} -
          ${moment(endTime).format('h A')}`
      : t('not available');
  };

  const renderEwayBillList = (ewayBillList) => {
    setEwayBillListModalVisible(true);
    setEwayBillList(ewayBillList);
  };
  const renderEwayBillPartBList = (ewayBillList) => {
    setEwayBillPartBListModalVisible(true);
    setEwayBillList(ewayBillList);
  };

  const renderEwayBillNo = (ewayBill, ewayBillList) => {
    if (ewayBill) {
      try {
        const wayBillObject = JSON.parse(ewayBill.trim());
        return (
          <span>
            {wayBillObject['ewbNumber']?.toString()}
            <Tooltip title="">
              <a>
                <InfoCircleOutlined
                  style={{ marginLeft: theme.spacing[1] }}
                  onClick={() => renderEwayBillList(ewayBillList)}
                ></InfoCircleOutlined>
              </a>
            </Tooltip>
          </span>
        );
      } catch (err) {
        return t('not available');
      }
    }
    return t('not available');
  };

  const renderEwayBillValidity = (ewayBill) => {
    if (ewayBill) {
      try {
        const wayBillObject = JSON.parse(ewayBill);
        return formatDate(wayBillObject['validTill'], t('not available'));
      } catch (err) {
        return t('not available');
      }
    }
    return t('not available');
  };

  const renderEWBPartBGenerationTime = (epochTime) => {
    if (epochTime) {
      try {
        return formatDate(epochTime, t('not available'));
      } catch (err) {
        return t('not available');
      }
    }
  };

  const renderEwayBillPartB = (ewayBill, ewayBillList) => {
    if (ewayBill) {
      try {
        const wayBillObject = JSON.parse(ewayBill.trim());
        return (
          <span>
            {wayBillObject['pickupCompletionPartBStatus']?.toString()}
            <Tooltip title="">
              <a>
                <InfoCircleOutlined
                  style={{ marginLeft: theme.spacing[1] }}
                  onClick={() => renderEwayBillPartBList(ewayBillList)}
                ></InfoCircleOutlined>
              </a>
            </Tooltip>
          </span>
        );
      } catch (err) {
        return t('not available');
      }
    }
    return t('not available');
  };

  const renderReferenceNos = (refNo) => {
    return refNo ? (
      <Link target={'_blank'} to={getDetailsRoute(encodeURIComponent(refNo))}>
        {refNo}

      </Link>
    ) : (
      t('not available')
    );
  };

  const renderBagNo = (refNo) => {
    return refNo ? (
      <Link to={getTMSBagDetailsRoute(refNo)}>{refNo}</Link>
    ) : (
      t('not available')
    );
  };

  const renderTripNumber = (tripNo, isMiddleMileTripNo?: boolean) => {
    return tripNo ? (
      <Link
        to={
          isMiddleMileTripNo
            ? getTMSIstDetailsRoute(tripNo)
            : getRetailTripDetailsRoute(tripNo)
        }
      >
        {tripNo}
      </Link>
    ) : (
      t('not available')
    );
  };

  const renderPickupTaskReferenceNumber = (referenceNumber) => {
    return referenceNumber ? (
      <Link
        target={'_blank'}
        to={getPickupRequestDetailsRoute(referenceNumber)}
      >
        {referenceNumber}
      </Link>
    ) : (
      t('not available')
    );
  };

  const renderTooltipParagraph = (textToDisplay) => {
    return (
      <Tooltip
        overlayInnerStyle={{
          backgroundColor: theme.color.semantic.background.neutral.subtle,
          color: theme.color.semantic.text.secondary,
          border: `${theme.border.width.sm} solid`,
        }}
        autoAdjustOverflow={true}
        title={textToDisplay}
      >
        <Paragraph
          ellipsis={{
            rows: 3,
          }}
        >
          {textToDisplay ? textToDisplay : t('not available')}
        </Paragraph>
      </Tooltip>
    );
  };

  const renderTableModal = (data, columnsData, header?) => {
    return data ? (
      <span>
        <Tooltip title="">
          <a>
            <InfoCircleOutlined
              style={{ marginLeft: theme.spacing[1] }}
              onClick={() => {
                setState({
                  isTableModalVisible: true,
                  dataSource: data,
                  columnsData,
                  header,
                });
              }}
            ></InfoCircleOutlined>
          </a>
        </Tooltip>
      </span>
    ) : (
      t('not available')
    );
  };

  const renderPodImage = (data) => {
    return data?.length ? (
      <span
        onClick={() =>
          setState({
            isPodModalVisible: true,
            podImagesList: data,
          })
        }
      >
        <a>{t('View')}</a>
      </span>
    ) : (
      t('not available')
    );
  };

  const renderConstraintTags = (data) => {
    return data?.length ? (
      <span>
        <TextWithEllipsisAndTooltip width="500px">
          {data.map((item, index) => {
            if (index === data.length - 1) {
              return item;
            }
            return item + ', ';
          })}
        </TextWithEllipsisAndTooltip>
      </span>
    ) : (
      t('not available')
    );
  };

  const getModifiedColumns = (columns = []) => {
    const temp = [...columns];
    temp.forEach((item) => {
      item.column_id = item.id;
    });
    return temp;
  };

  const getValueOrNotAvailable = (value: any, formatter?: (value: any) => any) => {
    if (value || value === 0) {
      return formatter ? formatter(value) : value;
    }
    return t('not available');
  };

  const getListValueOrNotAvailable = (values: any[], formatter?: (value: any) => any) => {
    if (!Array.isArray(values) || !values?.length) {
      return t('not available');
    }
    const formattedValues = formatter ? values?.map(formatter) : values;
    return formattedValues?.join(', ');
  };

  const renderPickupExtraDataRow = (label, value) => (
    <div className={classes.column}>
      <div className={classes.hintHeader}>{label}</div>
      <div className={classes.content}>{value}</div>
    </div>
  );

  const renderAddress = (column, data) => {
    return Array.isArray(column?.id) ? (
      <span>
        <TextWithEllipsisAndTooltip width="500px">
          <>
            {data[column.id[0]] ? data[column.id[0]] : ' - '}
            {data[column.id[1]] ? data[column.id[1]] : ''}
          </>
        </TextWithEllipsisAndTooltip>
      </span>
    ) : (
      t('not available')
    );
  };

  if (!Array.isArray(columns) || columns?.length === 0) {
    return <></>
  }

  const { t } = useTranslation();
  return (
    <div className={classes.container}>
      <div className={classes.title}>{t(title)}</div>
      <div className={classes.rowContainer}>
        <Row gutter={40}>
          {columns?.map((column, index) => {
            if (getCustomDetailsCard) {
              const dataToRender = getCustomDetailsCard(column, data);
              return dataToRender?.hint ? (
                <Col span={column.size ? 6 * column.size : 6} key={index}>
                  <div className={classes.column}>
                    <div className={classes.hintHeader}>
                      {t(dataToRender.hint)}
                    </div>
                    <div className={classes.content}>
                      {dataToRender.content ?? '-'}
                    </div>
                  </div>
                </Col>
              ) : null;
            }
            return (
              column && (
                <Col span={column.size ? 6 * column.size : 6} key={index}>
                  <div className={classes.column}>
                    <div className={classes.hintHeader}>
                      {getColumnPrettyName(column)}
                    </div>
                    <div className={classes.content}>
                      {getDataToRender(column, data)}
                    </div>
                  </div>
                </Col>
              )
            );
          })}
        </Row>
        <div style={{ display: 'none' }}>
          <PreviewGroup
            preview={{
              visible,
              onVisibleChange: (vis) => toggleGalleryWithData(),
            }}
          >
            {Array.isArray(galleryData) ? (
              galleryData?.map((url) => <Image src={url} placeholder={true} />)
            ) : (
              <Image src={galleryData} placeholder={true} />
            )}
          </PreviewGroup>
        </div>
      </div>
      {isLoading && (
        <div className={classes.loader}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} />
        </div>
      )}
      {isGalleryModalVisible && (
        <GalleryModal
          isVisible={isGalleryModalVisible}
          imageVideoGalleryData={galleryModalData}
          mediaList={mediaList}
          handleModalClose={() => {
            setIsGalleryModalVisible(false);
            setMediaList([]);
          }}
        />
      )}
      {isEwayBillListModalVisible && (
        <EwayBillListModal
          isVisible={isEwayBillListModalVisible}
          handleModalClose={(e) => setEwayBillListModalVisible(false)}
          ewayBillList={ewayBillList}
        />
      )}
      <InvoiceListModal
        isVisible={isInvoiceListModalVisible}
        handleModalClose={(e) => setIsInvoiceListModalVisible(false)}
        invoiceList={invoiceList}
      />
      {isEwayBillPartBListModalVisible && (
        <EwayBillPartBListModal
          isVisible={isEwayBillPartBListModalVisible}
          handleModalClose={(e) => setEwayBillPartBListModalVisible(false)}
          ewayBillList={ewayBillList}
        />
      )}
      {isTableModalVisible && (
        <TableModal
          header={header}
          isVisible={isTableModalVisible}
          handleModalClose={() =>
            setState({
              isTableModalVisible: false,
              dataSource: [],
              columnsData: [],
              header: '',
            })
          }
          dataSource={dataSource}
          columnsToShow={columnsData}
        />
      )}
      {isPodModalVisible && (
        <PodImageModal
          isVisible={isPodModalVisible}
          record={{ pod_image_url: podImagesList }}
          handleModalClose={() => setState({ isPodModalVisible: false })}
          title={'Delivery Image'}
        />
      )}
      {isCustomerFeedbackModalVisible && (
        <CustomerFeedbackModal
          isVisible={isCustomerFeedbackModalVisible}
          onModalClose={() => setIsCustomerFeedbackModalVisible(false)}
          feedbackData={data?.feedback}
          consignmentNumber={data?.reference_number}
        />
      )}
      {
        documentLinkModalVisible && (
          <DocumentDetailsModal
            isVisible={documentLinkModalVisible}
            onModalClose={() => {
              setDocumentLinkModalVisible(false);
              setDocumentDetails(null);
            }}
            documentDetails = {documentDetails}
          />
        )
      }
      {isPriceDataListModalVisible && (
        <PriceDataListModal
          isVisible={isPriceDataListModalVisible}
          handleModalClose={(e) => setIsPriceDataListModalVisible(false)}
          priceDataList={priceDataList}
        />
      )}
      {jsonArrayFieldListModalProps.isVisible && (
        <JsonArrayTableViewModal
          isVisible={jsonArrayFieldListModalProps.isVisible}
          data={jsonArrayFieldListModalProps.data}
          objectType={objectType}
          handleClose={() => {
            setJsonArrayFieldListModalProps({
              data: [],
              isVisible: false,
              key: '',
            });
          }}
          columnKey={jsonArrayFieldListModalProps.key}
        />
      )}
      {isExceptionsAppliedTableVisible && (
        <ExceptionDetailsModal
          isVisible={isExceptionsAppliedTableVisible}
          onModalClose={(e) => setIsExceptionsAppliedTableVisible(false)}
          appliedExceptionList={appliedExceptionsList}
        />
      )}
      {isPickupExtraDataModalVisible && (
        <Modal
          visible={isPickupExtraDataModalVisible}
          onCancel={() => {
            setIsPickupExtraDataModalVisible(false);
            setPickupExtraData(null);
          }}
          footer={null}
          title={t('expected_pickup_date_details')}
          bodyStyle={{ paddingTop: theme.spacing[3] }}
        >
          <div className={classes.epdModalContainer}>
            {renderPickupExtraDataRow(
              t('Start Date & Time'),
              getValueOrNotAvailable(
                pickupExtraData?.startDateTime,
                (value) => formatDateTime(value),
              ),
            )}
            {renderPickupExtraDataRow(
              t('Pickup Cutoff Time'),
              getValueOrNotAvailable(pickupExtraData?.pickupCutoffTime),
            )}
            {renderPickupExtraDataRow(
              t('Holidays'),
              getListValueOrNotAvailable(
                pickupExtraData?.holidays,
                (holiday) => moment(holiday)?.format('DD MMM YYYY'),
              ),
            )}
            {renderPickupExtraDataRow(
              t('Pickup Lead Time (Days)'),
              getValueOrNotAvailable(pickupExtraData?.pickupLeadTime),
            )}
            {renderPickupExtraDataRow(
              t('Pickup Days'),
              getListValueOrNotAvailable(pickupExtraData?.pickupDays),
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

const DetailsCardStyled = withStyles(styles, { injectTheme: true })(
  DetailsCard,
);

const mapStateToProps = ({ masterData }) => {
  return {
    allowPartialDelivery:
      masterData.ops_dashboard_config?.parts_to_show?.flm_trip_config
        ?.allow_partial_delivery,
    showChildCns: masterData.separate_child_cns,

  };
};

export default connect(mapStateToProps, null)(DetailsCardStyled);
